// extracted by mini-css-extract-plugin
export default {"textarea":"AddNotification_textarea__IAfSk","titre":"AddNotification_titre__se0Pc","form":"AddNotification_form__KRSDx"};